import { Tooltip } from "antd"
import PropTypes from "prop-types"
import SvgIcon from "src/components/SvgIcon"
import ButtonCustom from "../Button"

export default function ButtonCircle(props) {
  const { children, iconName, title, ...rest } = props

  return (
    <Tooltip title={title || children}>
      <ButtonCustom
        shape="circle"
        color="default"
        size={"large"}
        style={{ background: "#fff" }}
        {...rest}
      >
        <SvgIcon name={iconName} />
      </ButtonCustom>
    </Tooltip>
  )
}
ButtonCircle.propTypes = { iconName: PropTypes.string }

ButtonCircle.defaultProps = { iconName: "" }
